// ** Redux Imports
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
// ** Reducers Imports
import localforage from 'localforage';
import agents from 'views/screens/Agents/reducers';
import assets from 'views/screens/Assets/reducers';
import people from 'views/screens/Contacts/reducers';
import organizationContracts from 'views/screens/Contracts/reducers';
import contractTemplates from 'views/screens/ContractTemplates/reducers';
import customers from 'views/screens/Customers/reducers';
import divisions from 'views/screens/Divisions/reducers';
import drivers from 'views/screens/Drivers/reducers';
import entities from 'views/screens/Entities/reducers';
import etaModels from 'views/screens/ETAModelRoutes/reducers';
import forms from 'views/screens/Forms/reducers';
import geofences from 'views/screens/Geofences/reducers';
import groups from 'views/screens/Groups/reducers';
import jobs from 'views/screens/Jobs/reducers';
import locations from 'views/screens/Locations/reducers';
import maintenanceLines from 'views/screens/MaintenanceLines/reducers';
import modules from 'views/screens/Modules/reducers';
import userNotifications from 'views/screens/Notifications/reducers';
import operators from 'views/screens/Operators/reducers';
import organizations from 'views/screens/Organizations/reducers';
import protocols from 'views/screens/Protocols/reducers';
import quotations from 'views/screens/Quotations/reducers';
import routes from 'views/screens/Routes/reducers/routes';
import schedules from 'views/screens/Schedules/reducers';
import sensors from 'views/screens/Sensors/reducers';
import serviceClasses from 'views/screens/ServiceClasses/reducers';
import sims from 'views/screens/SIMs/reducers';
import subdivisions from 'views/screens/Subdivisions/reducers';
import units from 'views/screens/Units/reducers';
import monitoringUsers from 'views/screens/Users/reducers';
import categories from 'views/screens/vehicleMaintenance/reducers/catalogs/categories';
import providers from 'views/screens/vehicleMaintenance/reducers/catalogs/providers';
import spareParts from 'views/screens/vehicleMaintenance/reducers/catalogs/spareParts';
import workmanship from 'views/screens/vehicleMaintenance/reducers/catalogs/workmanship';
import noticesByDate from 'views/screens/vehicleMaintenance/reducers/preventiveNotices/noticesByDate';
import noticesByHourmeter from 'views/screens/vehicleMaintenance/reducers/preventiveNotices/noticesByHourmeter';
import noticesByOdometer from 'views/screens/vehicleMaintenance/reducers/preventiveNotices/noticesByOdometer';
import vehicles from 'views/screens/Vehicles/reducers';
import workplans from 'views/screens/Workplans/reducers/workplans';
import { whatsappReducer } from 'views/screens/WhatsApp/reducers';
import activityLog from 'views/screens/ActivityLog/reducers';
import * as authTypes from '../types/auth';
import auth from './auth';
import layout from './layout';
import navbar from './navbar';
import staticCatalogs from './static-catalogs';
import camelcaseKeys from 'camelcase-keys';
import jwtDecode from 'jwt-decode';

const reducers = {
  auth,
  layout,
  operators,
  organizations,
  divisions,
  subdivisions,
  serviceClasses,
  agents,
  navbar,
  modules,
  entities,
  people,
  workplans,
  locations,
  drivers,
  monitoringUsers,
  routes,
  schedules,
  units,
  categories,
  workmanship,
  geofences,
  staticCatalogs,
  sims,
  vehicles,
  assets,
  sensors,
  forms,
  jobs,
  groups,
  quotations,
  organizationContracts,
  contractTemplates,
  customers,
  form: formReducer,
  noticesByOdometer,
  noticesByDate,
  noticesByHourmeter,
  providers,
  spareParts,
  maintenanceLines,
  protocols,
  userNotifications,
  etaModels,
  whatsapp: whatsappReducer,
  activityLog
};

const reducer = combineReducers(reducers);

const rootReducer = (state, action, customReducer = reducer): any => {
  let newState = { ...state };

  if (!action) {
    return customReducer;
  }

  if (action.type === authTypes.AUTHENTICATION_IDENTITY_CLEARED) {
    let authState = state?.auth || {};

    // verificar si en payload viene un nuevo token
    if (action.payload && action.payload.newToken) {
      // Update localStorage with the new token
      localStorage.setItem('auth', action.payload.newToken);
      localStorage.setItem(
        'userData',
        JSON.stringify(camelcaseKeys(jwtDecode(action.payload.newToken)))
      );
    } else {
      //Remove Session Information
      localStorage.removeItem('auth');
      localStorage.removeItem('userData');
      //Clear redux-persist storage
      localforage.removeItem('persist:root');
    }

    //Set initialState
    const {
      jobs,
      groups,
      entities,
      routes,
      workplans,
      locations,
      drivers,
      auth,
      geofences,
      units
    } = state;
    newState = {
      jobs,
      groups,
      entities,
      routes,
      workplans,
      locations,
      drivers,
      auth,
      geofences,
      units
    };
  }
  return customReducer(newState, action);
};

export { reducers };
export default rootReducer;
export type RootState = ReturnType<typeof reducer>;
